import { ChainId } from '@pancakeswap/sdk'
import BigNumber from 'bignumber.js/bignumber'
import { BIG_TEN } from 'utils/bigNumber'
import { parseUnits } from 'ethers/lib/utils'

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

export const ASC_BLOCK_TIME = 2

export const BASE_BSC_SCAN_URLS = {
  [ChainId.MAINNET]: 'https://explorer.ariettachain.tech',
  [ChainId.TESTNET]: 'https://testnet.explorer.ariettachain.tech',
}

// ASCS_PER_BLOCK details
// 40 ASCS is minted per block
// 20 ASCS per block is sent to Burn pool (A farm just for burning cake)
// 10 ASCS per block goes to ASCS syrup pool
// 9 ASCS per block goes to Yield farms and lottery
// ASCS_PER_BLOCK in config/index.ts = 40 as we only change the amount sent to the burn pool which is effectively a farm.
// ASCS/Block in src/views/Home/components/CakeDataRow.tsx = 15 (40 - Amount sent to burn pool)
export const ASCS_PER_BLOCK = 0.001
export const BLOCKS_PER_YEAR = (60 / ASC_BLOCK_TIME) * 60 * 24 * 365 // 10512000
export const ASCS_PER_YEAR = ASCS_PER_BLOCK * BLOCKS_PER_YEAR
export const BASE_URL = 'https://arianswap.com'
export const BASE_ADD_LIQUIDITY_URL = `${BASE_URL}/add`
export const BASE_BSC_SCAN_URL = BASE_BSC_SCAN_URLS[ChainId.MAINNET]
export const DEFAULT_TOKEN_DECIMAL = BIG_TEN.pow(18)
export const DEFAULT_GAS_LIMIT = 400000
export const AUCTION_BIDDERS_TO_FETCH = 500
export const RECLAIM_AUCTIONS_TO_FETCH = 500
export const AUCTION_WHITELISTED_BIDDERS_TO_FETCH = 500
export const IPFS_GATEWAY = 'https://ipfs.io/ipfs'
// In reality its 10000 because of fast refresh, a bit less here to cover for possible long request times
export const PANASCS_BUNNIES_UPDATE_FREQUENCY = 8000


export const INFURA_ID = 'PkSg__OS-7f9zA6VGKy5UDEx1V28aD5-'
// export const RPC_URL = 'https://eth-mainnet.alchemyapi.io/v2/PkSg__OS-7f9zA6VGKy5UDEx1V28aD5-' // ethereum
// export const RPC_URL = 'https://bsc-dataseed1.binance.org' // BSC Mainnet
// export const RPC_URL = 'https://eth-rinkeby.alchemyapi.io/v2/PkSg__OS-7f9zA6VGKy5UDEx1V28aD5-' // rinkeby
// export const RPC_URL = 'https://eth-goerli.alchemyapi.io/v2/PkSg__OS-7f9zA6VGKy5UDEx1V28aD5-' // goerli
// export const RPC_URL = 'https://data-seed-prebsc-1-s1.binance.org:8545/' //BSC Testnet
// export const RPC_URL = 'https://matic-mumbai.chainstacklabs.com' // goerli
export const RPC_URL = 'https://stlgastupi.ariettachain.tech'
// export const RPC_URL = 'https://mainnet-rpc.bbcscan.io'
export const CHAIN = 92522 // 197978 // 197978 // 80001 // 5 // 4 // 97 //56

export enum GAS_PRICE {
  default = '5',
  fast = '6',
  instant = '7',
  testnet = '10',
}

export const GAS_PRICE_GWEI = {
  default: parseUnits(GAS_PRICE.default, 'gwei').toString(),
  fast: parseUnits(GAS_PRICE.fast, 'gwei').toString(),
  instant: parseUnits(GAS_PRICE.instant, 'gwei').toString(),
  testnet: parseUnits(GAS_PRICE.testnet, 'gwei').toString(),
}

export const SLIP_PAGE = 1

export const SUBGRAPH_URL = 'https://graphql.ariettachain.tech/subgraphs/name/wtl-subgraph'
export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000"

export const PINATA_API_KEY = '8be5a3675398ff8c5b4c' // 'cfa4a65c60da5c709fe1'
export const PINATA_API_SECRET = '63b6a386e521392d79a39638765237faa6b5ee59f49c4e7f03f9dfe899c3e0aa' // '50c5064e0631b65cd991a3411a969166395eb65ac0bffc4e3c4d097d8ac2aef7'

export const PINATA_GATEWAY = 'http://peach-bold-lungfish-165.mypinata.cloud'
export const PINATA_LINK = 'https://ipfs.io'

export const OPENAI_KEY = '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'

export const REPLICATE_API_TOKEN='r8_S1diyhcwvOhlpjEsSkpwkyRunen9j252kBK0W'

export const GET_IMAGE_URL = 'https://ariannftbe.ariettachain.tech/getImage'